export const CURRENCIES = [
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "GBP", name: "British Pound", symbol: "£" },
  { code: "INR", name: "Indian Rupee", symbol: "₹" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
  { code: "ZAR", name: "South African Rand", symbol: "R" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "RUB", name: "Russian Ruble", symbol: "₽" },
  { code: "KRW", name: "South Korean Won", symbol: "₩" },
  { code: "MXN", name: "Mexican Peso", symbol: "$" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺" },
  { code: "AED", name: "UAE Dirham", symbol: "د.إ" },
  { code: "SAR", name: "Saudi Riyal", symbol: "﷼" },
  { code: "THB", name: "Thai Baht", symbol: "฿" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱" },
  { code: "PLN", name: "Polish Zloty", symbol: "zł" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "ILS", name: "Israeli New Shekel", symbol: "₪" },
];




export const CURRENCIES_FILED = {
  USD: { symbol: "$", prefix: true, postfix: false },
  EUR: { symbol: "€", prefix: true, postfix: false },
  GBP: { symbol: "£", prefix: true, postfix: false },
  INR: { symbol: "₹", prefix: true, postfix: false },
  JPY: { symbol: "¥", prefix: true, postfix: false },
  CNY: { symbol: "¥", prefix: true, postfix: false },
  AUD: { symbol: "A$", prefix: true, postfix: false },
  CAD: { symbol: "C$", prefix: true, postfix: false },
  CHF: { symbol: "CHF", prefix: true, postfix: false },
  SEK: { symbol: "kr", prefix: true, postfix: false },
  NZD: { symbol: "NZ$", prefix: true, postfix: false },
  SGD: { symbol: "S$", prefix: true, postfix: false },
  ZAR: { symbol: "R", prefix: true, postfix: false },
  BRL: { symbol: "R$", prefix: true, postfix: false },
  RUB: { symbol: "₽", prefix: true, postfix: false },
  KRW: { symbol: "₩", prefix: true, postfix: false },
  MXN: { symbol: "$", prefix: true, postfix: false },
  TRY: { symbol: "₺", prefix: true, postfix: false },
  AED: { symbol: "د.إ", prefix: true, postfix: false },
  SAR: { symbol: "﷼", prefix: true, postfix: false },
  THB: { symbol: "฿", prefix: true, postfix: false },
  IDR: { symbol: "Rp", prefix: true, postfix: false },
  MYR: { symbol: "RM", prefix: true, postfix: false },
  PHP: { symbol: "₱", prefix: true, postfix: false },
  PLN: { symbol: "zł", prefix: false, postfix: true },
  NOK: { symbol: "kr", prefix: false, postfix: true },
  DKK: { symbol: "kr", prefix: false, postfix: true },
  CZK: { symbol: "Kč", prefix: false, postfix: true },
  HUF: { symbol: "Ft", prefix: false, postfix: true },
  ILS: { symbol: "₪", prefix: true, postfix: false }
};
